import { Role } from '../models/auth.dto';

/** Mirrors the backend's User.changeRole()/Role.requiresCompany() family boundary. */
const COMPANY_ROLES: Role[] = ['COMPANY_ADMIN', 'COMPANY_USER'];
const PLATFORM_ROLES: Role[] = ['SUPERADMIN', 'ADMIN', 'CUSTOMS', 'AUDITOR'];

export function rolesInSameFamily(role: Role): Role[] {
  return COMPANY_ROLES.includes(role) ? COMPANY_ROLES : PLATFORM_ROLES;
}
